import React, { useEffect } from "react"
import PropTypes from "prop-types"
import Modal from "@kit/design/modal"
import { PlanSwitchConfirmation } from "./plan-switch-confirmation"
import { analytics } from "utils/analytics"
import { discountTrackingProperties } from "app/shared/components/billing/discount-tracking"

export function PlanSwitchConfirmationModal({
  label,
  onClose,
  fromPlan,
  toPlan,
  onCancel,
  onConfirm,
  disableButton,
  message,
  newPlanLabel,
  confirmLabel,
  tracking = {}
}) {
  const { location, monthly_difference_displayed = null } = tracking

  useEffect(() => {
    analytics.track("Element", "Opened", {
      element_type: "modal",
      name: "plan_switch_confirmation",
      label: label,
      location: location,
      from_plan: fromPlan.display_name,
      to_plan: toPlan.display_name,
      monthly_difference_displayed: monthly_difference_displayed,
      monthly_difference: toPlan.monthly_difference ?? null,
      ...discountTrackingProperties(toPlan)
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <Modal
      label={label}
      onClose={onClose}
      data-testid="plan-switch-confirmation-modal"
    >
      <PlanSwitchConfirmation
        fromPlan={fromPlan}
        toPlan={toPlan}
        onCancel={onCancel}
        onConfirm={onConfirm}
        disableButton={disableButton}
        message={message}
        newPlanLabel={newPlanLabel}
        confirmLabel={confirmLabel}
        tracking={tracking}
      />
    </Modal>
  )
}

PlanSwitchConfirmationModal.propTypes = {
  label: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
  fromPlan: PropTypes.object.isRequired,
  toPlan: PropTypes.object.isRequired,
  onCancel: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  disableButton: PropTypes.bool,
  message: PropTypes.string,
  newPlanLabel: PropTypes.string,
  confirmLabel: PropTypes.string,
  tracking: PropTypes.shape({
    location: PropTypes.string,
    monthly_difference_displayed: PropTypes.bool
  })
}
